import * as R from 'remeda';
import { Url } from '@rossum/api-client';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { toDict } from '../../document-list-base/helpers/toDict';
import { useRequestUnpaginatedLabels } from '../../labels/hooks/useRequestLabels';
import { TransformedAnnotation } from '../hooks/useTransformAnnotation';
import { LabelsColumn } from './LabelsColumn';

export type SimpleLabelsRowContext = Pick<TransformedAnnotation, 'labels'>;

export const SimpleLabels = (
  cellProps: GridRenderCellParams<SimpleLabelsRowContext, Url[]>
) => {
  const { data: labels } = useRequestUnpaginatedLabels({ select: toDict });
  return (
    <LabelsColumn
      labels={R.pipe(
        cellProps.row.labels.map(labelUrl => (labels ?? {})[labelUrl]),
        R.filter(R.isTruthy)
      )}
      maxVisibleLabelCount={1}
    />
  );
};
